import React from 'react';
import ReactModal from 'react-modal';
import Loader from '../common/Loader';
import './RetentionKidModal.css';

const RetentionKidModal = ({ isOpen, onClose, title, kids, loading, seasonsReturnedMap, totalSeasons }) => {
  const handleDownloadCsv = () => {
    if (!kids.length) return;

    const headers = ['Name', 'Contact Name', 'Email', 'Phone'];
    if (kids[0]?.programName !== undefined) {
      headers.push('Program');
    }
    if (seasonsReturnedMap) {
      headers.push('Seasons Returned');
    }

    const rows = kids.map(kid => {
      const row = [
        `${kid.firstName || ''} ${kid.lastName || ''}`.trim(),
        `${kid.contactFirstName || ''} ${kid.contactLastName || ''}`.trim(),
        kid.contactEmail || '',
        kid.contactPhone || ''
      ];
      if (kids[0]?.programName !== undefined) {
        row.push(kid.programName || '');
      }
      if (seasonsReturnedMap) {
        row.push(seasonsReturnedMap[kid.id] || 0);
      }
      return row;
    });

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${title.replace(/[^a-z0-9]/gi, '_')}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      contentLabel={title}
      ariaHideApp={false}
      className="retention-kid-modal-content"
      overlayClassName="modal-overlay"
    >
      <div className="retention-kid-modal">
        <button className="close-button" onClick={onClose}>×</button>
        <h2>{title}</h2>

        {loading ? (
          <Loader size={50} />
        ) : (
          <>
            <div className="modal-actions">
              <button className="download-csv-button" onClick={handleDownloadCsv}>
                Download CSV
              </button>
            </div>
            <div className="kid-table-container">
              <table className="kid-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Email</th>
                    <th>Phone</th>
                    {kids[0]?.programName !== undefined && <th>Program</th>}
                    {seasonsReturnedMap && <th>Seasons Returned</th>}
                  </tr>
                </thead>
                <tbody>
                  {kids.map((kid, index) => (
                    <tr key={kid.id || index}>
                      <td className="kid-name-cell">{kid.firstName} {kid.lastName}</td>
                      <td>{kid.contactFirstName} {kid.contactLastName}</td>
                      <td>{kid.contactEmail || '-'}</td>
                      <td>{kid.contactPhone || '-'}</td>
                      {kids[0]?.programName !== undefined && (
                        <td>{kid.programName || '-'}</td>
                      )}
                      {seasonsReturnedMap && (
                        <td className="seasons-cell">
                          {seasonsReturnedMap[kid.id] || 0} / {totalSeasons}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </ReactModal>
  );
};

export default RetentionKidModal;
